import React, { useEffect, useRef, useState, useCallback } from "react";
import "./AuditorView.css";
import uncodedIcon from "../../../common/assets/images/uncoded.png";
import urgentIcon from "../../../common/assets/images/Variation 2.png";
import overDueIcon from "../../../common/assets/images/overdue.png";
import backIcon from "../../../common/assets/images/back-icon.png";
import inprogressIcon from "../../../common/assets/images/inprogress.png";
import userIcon from "../../../common/assets/images/user-icon.png";
import generalsurgeryIcon from "../../../common/assets/images/general-surgery-icon.png";
import workflowFilterIcon from "../../../common/assets/images/workflow-filter-icon.png";
import LdsRoller from "../../../utils/LdsRoller";
import closeIcon from "../../../common/assets/images/modal-close-icon.png";
import search_icon from "../../../common/assets/images/search-icon-new.png"
import { toast, ToastContainer } from "react-toastify";
import { debounce } from "lodash";
import {
  Table,
  Badge,
  Form,
  Pagination,
  Dropdown,
  Button,
  Card,
  Placeholder,
  Spinner,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatCalenderDate } from "../../CodingScreen/utils";
import { Tooltip } from "@mui/material";
import {
  getAuditorViewData,
  getAuditorViewStatsData,
  getauditorViewFilterOptions,
  specialityOptions,
  queueOptions,
  URnumberOptions,
  updateFilters,
  updateSpecialityPageNumber,
  updateQueuePageNumber,
  updateUserPageNumber,
  updateComponentState,
  updateAuditorPage,
  getAllQueuesData,
} from "./redux/AuditorViewSlicer";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserPreferences } from "../CoderView/redux/CoderScreenSlice";
import { useNavigate } from "react-router-dom";
import { resetDocumentViewerError, resetDocumentViewerLoadedData, resetEpisodeIdentifierTopassDocumentViewer } from "../../DocumentViewer/redux/DocumentViewerSlicer";
import { selectedEpisodeList } from "../../pages/EpisodeList/redux/EpisodeListSlicer";
import { useMediaQuery } from "@mui/material";
import AuditorSideDrawer from "./mobile/AuditorSideDrawer";

const AuditorView = () => {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  // declaration
  const dispatch = useDispatch();
  const dateFormat = "dd-MM-yyyy";
  const navigate = useNavigate();
  const appliedFiltersRef = useRef();

  // selectors
  const { auditorViewFiltersPriority, auditorViewFiltersStatus } = useSelector(
    (state) => state.auditorView.auditorViewFilters
  );
  const {
    specialityPageNumber,
    specialityData,
    specialityLoading,
    specialityError,
    isSpecialityPageTrue,
  } = useSelector((state) => state.auditorView.speciality);
  const {
    episodesURnumberPageNumber,
    episodesURnumberData,
    episodesURnumberLoading,
    episodesURnumberError,
    isEpisodesURnumberPageTrue,
  } = useSelector((state) => state.auditorView.episodesURnumber);
  const {
    queuePageNumber,
    queueData,
    queueLoading,
    queueError,
    isQueuePageTrue,
  } = useSelector((state) => state.auditorView.queue);
  const filtersPayload = useSelector(
    (state) => state.auditorView.auditorViewEpisodesPayload
  );
  const userPreferences = useSelector(
    (state) => state.coderscreenqueue.preferencesData
  );
  const {
    auditorViewStatsLoading,
    auditorViewStatsData,
    auditorViewStatsError,
  } = useSelector((state) => state.auditorView.auditorViewStats);

  const {
    queuesData,
    queuesLoading,
    queuesError,
  } = useSelector((state) => state.auditorView.getQueuesData);

  const { auditorViewData, auditorViewDataLoading, auditorViewDataError } =
    useSelector((state) => state.auditorView.auditorViewResponse);

  // states
  const [episodesCurrentPage, setEpisodesCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [workflowHimsAssginModal, setWorkflowHimsAssginModal] = useState(false);
  const [episodesPerPage, setEpisodesPerPage] = useState(10);
  const [selectedHimEpisodes, setSelectedHimEpisodes] = useState([]);
  const [isAllEpisodesSelected, setIsAllEpisodesSelected] = useState(false);
  const [showFilterSection, setShowFilterSection] = useState(true);
  const [appliedFilterModal, setAppliedFilterModal] = useState(false);
  const [episodesData, setEpisodesData] = useState([]);
  const [specialitySearchValue, setSpecialitySearchValue] = useState("");
  const [currentQueueSearchValue, setCurrentQueueSearchValue] = useState("");
  const [codersSearchValue, setCodersSearchValue] = useState("");
  const [prioritySearchValue, setPrioritySearchValue] = useState("");
  const [statusSearchValue, setStatusSearchValue] = useState("");
  const [uncheckedIds, setUncheckedIds] = useState([]);
  const [episodesToDisplay, setEpisodesToDisplay] = useState("");
  const [showUserPreferenceModal, setShowUserPreferenceModal] = useState(false);
  const preferencesLoading = useSelector(
    (state) => state.coderscreenqueue.loadingPreferencesData
  );
  const auditorContainerRef = useRef(null);
  const [auditorTotalCount, setAuditorTotalCount] = useState(0);
  const [isAuditorQueueFetching, setIsAuditorQueueFetching] = useState(false);
  const auditorqueueLengthRef = useRef(0);
  const auditorPageRef = useRef(1);
  const [auditorQueues, setAuditorQueues] = useState([]);
  const [auditorPage, setAuditorPage] = useState(1);
  const queueLengthRef = useRef(0);
  const pageRef = useRef(1);
  const totalPages =
    (typeof auditorViewData?.episode_meta_data?.meta?.total_count === 'number' &&
      typeof 10 === 'number' &&
      10 > 0)
      ? Math.ceil(
        auditorViewData?.episode_meta_data?.meta?.total_count / 10
      )
      : 0;
  // const indexOfLastEpisode = filtersPayload.page_number * episodesPerPage;
  // const indexOfFirstEpisode = indexOfLastEpisode - episodesPerPage;
  // const currentEpisodesList = episodesData?.slice(
  // indexOfFirstEpisode,
  // indexOfLastEpisode
  // );

  const dataToDisplay = episodesData?.length > 0 && episodesData;

  const auditorDashboardOptions =
    auditorViewData?.cards &&
    Object.keys(auditorViewData?.cards[0])?.map((item) => {
      return {
        name:
          item === "urgent"
            ? " Urgent"
            : item === "episode_to_be_audited"
              ? "Episodes to Audit"
              : item === "cdq_for_review"
                ? "CDQs for Review"
                : "",
        count: auditorViewData?.cards[0][item],
        icon:
          item === "urgent"
            ? urgentIcon
            : item === "episode_to_be_audited"
              ? uncodedIcon
              : item === "cdq_for_review"
                ? inprogressIcon
                : "",
        tooltipContent:
          item === "urgent"
            ? "You have 10 urgent episodes awaiting coding"
            : item === "episode to be audited"
              ? "You have 10 episode to be audited episodes pending allocation"
              : item === "overdue"
                ? "You have 10 episodes that are overdue for completion"
                : item === "in_progress"
                  ? "You have 10 ongoing episodes in progress"
                  : "",
        backgroundColor:
          item === "urgent"
            ? "#FEF2F2"
            : item === "episode_to_be_audited"
              ? "#EFF6FF"
              : item === "overdue"
                ? "#FEFCE8"
                : item === "cdq_for_review"
                  ? "#ECFDF5"
                  : "",
      };
    });

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...filtersPayload,
        page_number: pageNumber,
      };
      dispatch(getAuditorViewData(payload));
      dispatch(updateFilters(payload));
      // setEpisodesCurrentPage(pageNumber);
    }
  };

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...filtersPayload,
      page_number: 1,
    };
    dispatch(getAuditorViewData(payload));
    dispatch(updateFilters(payload));
    setEpisodesPerPage(Number(event.target.value));
  };

  const handleHimSelectChange = (fieldName, value) => {
    const currentValues = filtersPayload[fieldName] || [];
    let updatedValues = [];

    if (Array.isArray(value)) {
      updatedValues = value;
    } else {
      updatedValues = currentValues.includes(value)
        ? currentValues.filter((item) => item !== value)
        : [...currentValues, value];
    }

    const updatedFilters = {
      ...filtersPayload,
      page_number: 1,
      [fieldName]: updatedValues,
    };
    dispatch(updateFilters(updatedFilters));
    dispatch(getAuditorViewData(updatedFilters)).then((res) => {
      setEpisodesToDisplay(res.payload.episodes);
    });
    const keysToRemove = ["queue_page_number", "page_number"];
    const statsPayload = { ...updatedFilters };
    keysToRemove.forEach((key) => {
      delete statsPayload[key];
    });
    dispatch(getAuditorViewStatsData(statsPayload));
  };

  const handleHimDatePickerChange = (fieldName, date) => {
    let filteredData = episodesData;

    const updatedFilters = {
      ...filtersPayload,
      page_number: 1,
      [fieldName === fieldName ? fieldName : fieldName]:
        formatCalenderDate(date),
    };

    if (updatedFilters.separation_date_from) {
      filteredData = filteredData.filter(
        (item) =>
          item.separation_date_from === updatedFilters.separation_date_from
      );
    }

    if (updatedFilters.separation_date_to) {
      filteredData = filteredData.filter(
        (item) => item.separation_date_to === updatedFilters.separation_date_to
      );
    }
    dispatch(updateFilters(updatedFilters));
    dispatch(getAuditorViewData(updatedFilters)).then((res) => {
      setEpisodesToDisplay(res.payload.episodes);
    });

    const keysToRemove = ["queue_page_number", "page_number"];
    const statsPayload = { ...updatedFilters };
    keysToRemove.forEach((key) => {
      delete statsPayload[key];
    });
    dispatch(getAuditorViewStatsData(statsPayload));
    // setFilterEpisodes(updatedFilters);
    // setEpisodesData(filteredData);
  };

  const hanldeSelectQueueEpisodes = (type, data) => {
    if (type === "queue") {
      const payload = {
        page_number: 1,
        ...filtersPayload,
        // coders: [],
        queue: [data.queue_id],
      };
      setSelectedHimEpisodes([]);
      dispatch(updateFilters(payload));
      dispatch(getAuditorViewData(payload)).then((res) => {
        setEpisodesToDisplay(res.payload.episodes);
      });
      const keysToRemove = ["queue_page_number", "page_number"];
      const statsPayload = { ...payload };
      keysToRemove.forEach((key) => {
        delete statsPayload[key];
      });
      dispatch(getAuditorViewStatsData(statsPayload));
    }
  };

  const renderDropdownOptions = (type, options, selected, searchValue) => {
    return options?.length > 0 ? (
      options
        ?.filter((item) =>
          item?.toLowerCase()?.includes(searchValue?.toLowerCase())
        )
        .map((item) => (
          <Form.Check
            key={item}
            type="checkbox"
            className="workflow-auditor-dropdown-menu-options"
            label={item}
            value={item}
            checked={selected?.includes(item)}
            onChange={() => handleHimSelectChange(type, item)}
          />
        ))
    ) : (
      <div className="filter-no-options">No Options</div>
    );
  };

  const handleFilterRemove = (filterName, item) => {
    const updatedFilterObj = { ...filtersPayload };
    if (Array.isArray(updatedFilterObj[filterName])) {
      updatedFilterObj[filterName] = updatedFilterObj[filterName]?.filter(
        (value) => value !== item
      );
    } else {
      updatedFilterObj[filterName] = filterName === "date" ? null : "";
    }
    dispatch(updateFilters(updatedFilterObj));
    dispatch(getAuditorViewData(updatedFilterObj)).then((res) => {
      setEpisodesToDisplay(res.payload.episodes);
    });
    const keysToRemove = ["queue_page_number", "page_number"];
    const statsPayload = { ...updatedFilterObj };
    keysToRemove.forEach((key) => {
      delete statsPayload[key];
    });
    dispatch(getAuditorViewStatsData(statsPayload));
    // setFilterEpisodes(updatedFilterObj);
  };

  const keysToRemove = ["queue_page_number", "page_number"];
  const newObj = { ...filtersPayload };
  keysToRemove.forEach((key) => {
    delete newObj[key];
  });
  const hasValue = Object?.values(newObj)?.some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array?.isArray(item) ? item?.length > 0 : true)
  );

  const handleReset = () => {
    const resetState = {
      separation_date_from: null,
      separation_date_to: null,
      speciality: [],
      queue: [],
      queue_priority: [],
      status: [],
      queue_page_number: 1,
      page_number: 1,
      ur_number: [],
    };
    dispatch(updateFilters(resetState));
    dispatch(getAuditorViewData(resetState)).then((res) => {
      setEpisodesToDisplay(res?.payload?.episodes);
    });
    const keysToRemove = ["queue_page_number", "page_number"];
    const statsPayload = { ...resetState };
    keysToRemove.forEach((key) => {
      delete statsPayload[key];
    });
    dispatch(getAuditorViewStatsData(statsPayload));
    // setFilterEpisodes(resetState);
  };

  useEffect(() => {
    dispatch(getauditorViewFilterOptions());
    dispatch(getAuditorViewStatsData(newObj));
    dispatch(getAllQueuesData(filtersPayload))
    dispatch(getAuditorViewData(filtersPayload));
    // dispatch(getAuditorViewData(filtersPayload));
  }, []);

  // useEffect(() => {
  //   // const fetchData = async () => {
  //   //   try {
  //   //     const resultAction = await dispatch(getAuditorViewData(filtersPayload));
  //   //     const responseData = resultAction.payload;
  //   //     setEpisodesToDisplay(responseData?.episodes);
  //   //     console.log(responseData, "checkresdata");

  //   //     if (!responseData || responseData.episodes.length === 0) {
  //   //       setHasMoreData(false);
  //   //     } else {
  //   //       setHasMoreData(true);
  //   //     }
  //   //   } catch (error) {
  //   //     console.error("Failed to fetch data:", error);
  //   //     setHasMoreData(false);
  //   //   }
  //   // };

  //   // fetchData();

  // }, []);



  useEffect(() => {
    if (isQueuePageTrue && !queueLoading) {
      dispatch(updateQueuePageNumber(queuePageNumber + 1));
      dispatch(queueOptions(queuePageNumber + 1));
    }
  }, [isQueuePageTrue, queueLoading]);

  useEffect(() => {
    if (isSpecialityPageTrue && !specialityLoading) {
      dispatch(updateSpecialityPageNumber(specialityPageNumber + 1));
      dispatch(specialityOptions(specialityPageNumber + 1));
    }
  }, [isSpecialityPageTrue, specialityLoading]);

  useEffect(() => {
    if (isEpisodesURnumberPageTrue && !episodesURnumberLoading) {
      dispatch(updateUserPageNumber(episodesURnumberPageNumber + 1));
      dispatch(URnumberOptions(episodesURnumberPageNumber + 1));
    }
  }, [isEpisodesURnumberPageTrue, episodesURnumberLoading]);

  useEffect(() => {
    setEpisodesData(auditorViewData.episodes);
  }, [auditorViewData]);

  const getValueFromApi = (key, itemId) => {
    // console.log(key, "key");
    if (key === "queue") {
      const queues = queueData || [];
      const matchedQueue = queues.find((q) => q?.queue_id === itemId);
      return matchedQueue?.queue_name || itemId;
    }
    // else if (key === "ur_number") {
    //   const users = usersData || [];
    //   const matchedUser = users.find((u) => u?.user_id === itemId);
    //   return matchedUser?.user_name || itemId;
    // }
    return itemId;
  };
  const checkAuditorPermissionAndNavigate = (selectedRecord) => {
    const updatedRecord = {
      ...selectedRecord,
      episode_identifier: selectedRecord.medical_record_number,
    };
    localStorage.setItem("last_hcp_line_id", updatedRecord?.hcp_line_id);
    //navigate("/target-page", { state: { from: "coder" } });
    dispatch(resetEpisodeIdentifierTopassDocumentViewer())
    // localStorage.setItem('filters', JSON.stringify(filtersPayload));
    localStorage.setItem('currentPage', 'auditorPage');
    dispatch(resetDocumentViewerLoadedData());
    dispatch(selectedEpisodeList(updatedRecord));
    dispatch(resetDocumentViewerError())
    dispatch(fetchUserPreferences()).then((res) => {
      const preferences = res.payload; // get the latest preferences from thunk result

      if (preferences["Code Accelerate"] && preferences["Code Assist"]) {
        setShowUserPreferenceModal(true);
      } else if (preferences["Code Accelerate"]) {
        navigate("/Auditor-Coding-Screen", { state: { from: "auditor" } });
      } else if (preferences["Code Assist"]) {
        navigate("/Auditor-CodeAssist-Screen", { state: { from: "auditor" } });
      } else {
        toast.error("You are not subscribed to any of the coding module");
      }
    });
  };
  const navigateToDesiredPage = (type) => {
    if (type === "accelerate") {
      navigate("/Auditor-Coding-Screen", { state: { from: "auditor" } });
    } else if (type === "assist") {
      navigate("/Auditor-CodeAssist-Screen", { state: { from: "auditor" } });
    }
    localStorage.setItem('filters', JSON.stringify(filtersPayload));
    dispatch(updateAuditorPage(true));
    setShowUserPreferenceModal(false);
  };

  const getStatsDetails = () => {
    const statsDetails = auditorViewStatsData?.stats?.find(item => 'total_number_of_episodes' in item);
    return statsDetails;
  };
  useEffect(() => {
    const { page_number, ...rest } = filtersPayload;
    const initialPayload = {
      ...rest,
      queue_page_number: 1,
    };

    dispatch(getAllQueuesData(initialPayload)).then((res) => {
      const response = res.payload;
      setAuditorQueues(response.queues);
      setAuditorTotalCount(response.episode_queue_meta_data?.meta?.total_count || 0);
      setAuditorPage(1);
      queueLengthRef.current = response?.queues?.length;
      pageRef.current = 1;
    });
  }, [dispatch]);
  // console.log(auditorQueues,'auditorQueues');

  useEffect(() => {
    const container = auditorContainerRef?.current;
    if (!container) return;

    const handleScroll = () => {
      if (isAuditorQueueFetching) return;
      if (auditorqueueLengthRef.current >= auditorTotalCount) return;

      const reachedBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight - 5;

      if (reachedBottom) {
        const nextPage = auditorPageRef.current + 1;

        const { page_number, ...rest } = filtersPayload;
        const payloadWithPage = {
          ...rest,
          queue_page_number: nextPage,
        };

        setIsAuditorQueueFetching(true);
        dispatch(getAllQueuesData(payloadWithPage)).then((res) => {
          const response = res.payload;

          if (!response.queues || response.queues.length === 0) {
            setIsAuditorQueueFetching(false);
            return;
          }

          setAuditorQueues((prev) => {
            const updated = [...prev, ...response.queues];
            auditorqueueLengthRef.current = updated.length;
            return updated;
          });

          setAuditorPage(nextPage);
          auditorPageRef.current = nextPage;
          setIsAuditorQueueFetching(false);
        }).catch(() => setIsAuditorQueueFetching(false));
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [filtersPayload, auditorTotalCount, isAuditorQueueFetching]);

  const debounceSearchHandler = useCallback(
    debounce((payload) => {
      dispatch(getAuditorViewData(payload))
    }, 1000),
    []
  );

  const handleSearchEpisode = (e) => {
    const payload = {
      ...filtersPayload,
      search_term: e?.target?.value?.length > 0 ? e?.target?.value : '',
    };
    dispatch(updateFilters(payload));
    debounceSearchHandler(payload);
  }

  const getHighlightedText = (text) => {
    const fullText = text || '';
    const search = filtersPayload?.search_term || '';

    const index = fullText?.toLowerCase()?.indexOf(search?.toLowerCase());

    if (index === -1 || !search) {
      return fullText;
    }

    const before = fullText?.slice(0, index);
    const match = fullText?.slice(index, index + search?.length);
    const after = fullText?.slice(index + search.length);

    return (
      <>
        {before}
        <span style={{ backgroundColor: 'yellow' }}>{match}</span>
        {after}
      </>
    );
  };

  useEffect(() => {
    if (appliedFilterModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [appliedFilterModal]);

  const handleClickOutside = (event) => {
    if (
      appliedFiltersRef.current &&
      !appliedFiltersRef.current.contains(event.target)
    ) {
      setAppliedFilterModal(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="workflow-auditor-container">
        {!isMobile && (
          <div
            lg="3"
            sm="12"
            xs="12"
            md="12"
            className="left-auditor-workflow-card"
          >
            <div className="left-auditor-workflow-card-top-header">
              <img
                src={backIcon}
                className="left-auditor-workflow-card-icon"
                onClick={() => navigate('/Code-Workflow')}
              />
              <p className="left-auditor-workflow-card-text">Back to Workflow</p>
            </div>
            <div className="left-auditor-workflow-card-header">
              <p className="left-auditor-workflow-card-heading-text">My Tasks</p>
              <div className="left-auditor-workflow-top-card">
                <p className="left-auditor-workflow-card-subheading-text">
                  For Audit
                </p>
                <p className="left-auditor-workflow-card-count">{`(${auditorViewData?.for_audited?.[0]?.number_of_episodes ?? 0
                  })`}</p>
              </div>
            </div>
            <div className="left-auditor-workflow-queues-card">
              <p className="left-auditor-workflow-queues-card-header">Queues</p>
              <div className="auditor-workflow-queues-container" ref={auditorContainerRef}>
                {isAuditorQueueFetching ? (
                  <div className="left-auditor-workflow-queues-card-top">
                    {/* <LdsRoller/>  */}
                    <div style={{ width: "100%", minHeight: "300px" }}>
                      <Placeholder animation="glow">
                        <Placeholder xs={12} className="queuePlaceholder" />
                      </Placeholder>
                    </div>
                  </div>
                ) : queuesError ? (
                  <div className="left-auditor-workflow-queues-error">
                    {" "}
                    No queues found{" "}
                  </div>
                ) : (
                  auditorQueues?.map((queriesItem) => (
                    <div
                      className="left-auditor-workflow-queues-card-top"
                      key={queriesItem?.queue_id}
                      // onDragOver={handleDragOver}
                      // onDrop={(e) =>
                      //   handleDrop(e, queriesItem.queue_name, "queues")
                      // }
                      onClick={() =>
                        hanldeSelectQueueEpisodes("queue", queriesItem)
                      }
                    >
                      <p className="left-auditor-workflow-queues-card-icon">
                        <img
                          src={generalsurgeryIcon}
                          alt={queriesItem?.queue_id}
                        />
                      </p>
                      <p
                        className="left-auditor-workflow-queues-card-name"
                      // title={queriesItem.queue_name}
                      >
                        {queriesItem?.queue_name?.length > 20 ? (
                          <Tooltip title={queriesItem?.queue_name}>
                            {`${queriesItem?.queue_name[0]?.toUpperCase()}${queriesItem.queue_name?.slice(1, 20)}...`}
                          </Tooltip>
                        ) : (
                          `${queriesItem?.queue_name[0]?.toUpperCase()}${queriesItem?.queue_name?.slice(1)}`
                        )}
                      </p>
                      <p className="left-auditor-workflow-queues-card-count">
                        {`( ${queriesItem?.number_of_episodes} )`}
                        {/* <Tooltip title={`This queue contains ${queriesItem.number_of_episodes} episode assigned for processing`}>
                      <FontAwesomeIcon icon={faCircleInfo}  className="auditor-dashboard-tooltip"/>
                    </Tooltip> */}
                      </p>
                    </div>
                  ))
                )}
              </div>
              {/* <div className="cdqs-review-section">
              <p className="cdqs-review-text">CDQs for Review</p>
              <p className="cdqs-review-responses​">5 unread responses​</p>
          </div>
            <div className="feedback-section">
              <p className="feedback-text">Feedback</p>
              <p className="feedback-responses​">No unread messages​​</p>
          </div> */}
              <div className="stats-section">
                <p className="stats-text">My Stats</p>
                {auditorViewStatsLoading ? (
                  <Placeholder animation="glow">
                    <Placeholder xs={12} className="statsPlaceholder" />
                  </Placeholder>
                ) : (
                  <div>
                    <div className="stats-value-wrapper">
                      <label>Audited</label>
                      <span>
                        {
                          getStatsDetails()?.total_number_of_episodes
                        }
                      </span>
                    </div>
                    <div className="stats-value-wrapper">
                      <label>NWAU</label>
                      <span>
                        {Number(getStatsDetails()?.total_weight)?.toFixed(4)}
                      </span>
                    </div>
                    <div className="stats-value-wrapper">
                      <label>$</label>
                      <span>
                        {/* {Number(getStatsDetails()?.total_weight.toFixed(4)).toFixed(4) * 6465} */}
                        {(Number(getStatsDetails()?.total_weight ?? 0) * 6465)?.toFixed(2)}

                        {/* {Number.isFinite(
                        auditorViewStatsData?.stats?.[1]?.total_weight
                      )
                        ? Math.round(
                            auditorViewStatsData.stats[1].total_weight * 6465
                          ).toLocaleString()
                        : 0} */}
                      </span>
                    </div>
                  </div>
                )}
                {/* <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic" className="stats-dropdown-text">
       Today
      </Dropdown.Toggle>
      <Dropdown.Menu>
      <Dropdown.Item eventKey="1" className="stats-dropdown-item">
        <p>Audited</p>
        <p>{`(${16})`}</p>
      </Dropdown.Item>
      <Dropdown.Item eventKey="2" className="stats-dropdown-item">
         <p>NWAU</p>
        <p>{`(${21.6615})`}</p>
      </Dropdown.Item>
      <Dropdown.Item eventKey="3" className="stats-dropdown-item">
         <p>$</p>
        <p>{`($${"140042".toLocaleString()})`}</p>
      </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown> */}
              </div>
            </div>
          </div>
        )}
        <div className="right-auditor-workflow-card">
          {isMobile && (
            <div className="mobile-qc-header">
              <img
                src={backIcon}
                alt="back"
                className="mobile-qc-back-icon"
                onClick={() => navigate("/Code-Workflow")}
              />
              <span className="mobile-qc-back-text">Back to Workflow</span>
            </div>
          )}
          <div className="auditor-dashboard">
            {auditorViewDataLoading ? (
              <Placeholder
                as={Card.Text}
                animation="glow"
                style={{ width: "100%" }}
              >
                <Placeholder xs={4} className="PlaceholderItem" />{" "}
                <Placeholder xs={4} className="PlaceholderItem" />{" "}
                <Placeholder xs={3} className="PlaceholderItem" />{" "}
                {/* <Placeholder xs={2} className="PlaceholderItem" /> */}
              </Placeholder>
            ) : (
              auditorDashboardOptions?.length > 0 &&
              auditorDashboardOptions?.map((dashboardItem) => (
                <div
                  key={dashboardItem?.name}
                  className="auditor-dashboard-cards"
                  style={{ backgroundColor: dashboardItem?.backgroundColor }}
                >
                  <div className="auditor-dashboard-cards-top">
                    <p className="auditor-dashboard-name">{dashboardItem?.name}</p>
                    <p className="auditor-dashboard-icon">
                      <img src={dashboardItem?.icon} alt={dashboardItem?.name} />
                    </p>
                  </div>
                  <p className="auditor-dashboard-count">{dashboardItem?.count}</p>
                </div>
              ))
            )}
          </div>
          {isMobile && (
            <div className="mobile-view-filter">
              <AuditorSideDrawer
                auditorQueues={auditorQueues}
                auditorViewData={auditorViewData}
                isAuditorQueueFetching={isAuditorQueueFetching}
                queuesError={queuesError}
                auditorViewStatsLoading={auditorViewStatsLoading}
                getStatsDetails={getStatsDetails}
                hanldeSelectQueueEpisodes={hanldeSelectQueueEpisodes}
              />
            </div>
          )}
          <div className={showFilterSection ? "workflow-auditor-main-container-open" : "workflow-auditor-main-container-close"}>
            <div className="workflow-auditor-main-container-top">
              <p className="workflow-auditor-main-container-name">Filters</p>
              <div className="">
                {hasValue && (
                  <Button
                    className="workflow-auditor-applied-filter-btn"
                    onClick={() => setAppliedFilterModal(!appliedFilterModal)}
                  >
                    Applied Filter
                  </Button>
                )}
                <span
                  className="workflow-auditor-main-container-icon"
                  onClick={() => setShowFilterSection(!showFilterSection)}
                >
                  <img src={workflowFilterIcon} alt="" />
                </span>
              </div>
            </div>
            <>
              {appliedFilterModal && hasValue && (
                <div className="workflow-auditor-filter-breadcrumb-section" ref={appliedFiltersRef}>
                  <div className="workflow-auditor-filter-breadcrumb-list">
                    <p className="workflow-auditor-applied-header">Applied Filters</p>
                    {Object.keys(filtersPayload)?.map((key) => {
                      const value = filtersPayload[key];
                      if (
                        key === "separation_date_from" ||
                        key === "separation_date_to"
                      ) {
                        return (
                          value && (
                            <Badge
                              key={key}
                              bg="light"
                              text="dark"
                              className="workflow-auditor-filter-breadcrumbItem"
                            >
                              <span>
                                {key === "separation_date_from"
                                  ? "Separation Date From"
                                  : "Separation Date To"}{" "}
                                : {new Date(value).toLocaleDateString()}
                              </span>
                              <img
                                src={closeIcon}
                                height="15px"
                                width="15px"
                                onClick={() => handleFilterRemove(key)}
                                className="workflow-auditor-filter-close-icon"
                                alt={`Remove filter: ${key}`}
                              />
                            </Badge>
                          )
                        );
                      }
                      if (
                        key === "speciality" ||
                        key === "status" ||
                        key === "queue_priority" ||
                        key === "ur_number" ||
                        key === "queue"
                      ) {
                        return (
                          <div className="workflow-auditor-filter-breadcrumb-list">
                            {Array.isArray(value) ? (
                              value.map((item, index) => (
                                <Badge
                                  key={`${key}-${index}`}
                                  bg="light"
                                  text="dark"
                                  className="workflow-auditor-filter-breadcrumbItem"
                                >
                                  <span>
                                    {/* {console.log(item, "item")} */}
                                    {key.length > 0 &&
                                      key?.charAt(0)?.toUpperCase() +
                                      key?.slice(1)?.replace("_", " ")}
                                    {/* {key} */}:
                                    {/* {item.length > 0 &&
                                        item.replace(".txt", "")} */}{" "}
                                    {getValueFromApi(key, item)}
                                  </span>
                                  <span>
                                    <img
                                      src={closeIcon}
                                      height="15px"
                                      width="15px"
                                      onClick={() =>
                                        handleFilterRemove(key, item)
                                      }
                                      className="workflow-auditor-filter-close-icon"
                                      alt={`Remove filter: ${key}`}
                                    />
                                  </span>
                                </Badge>
                              ))
                            ) : (
                              <Badge
                                key={key}
                                bg="light"
                                text="dark"
                                className="workflow-auditor-filter-breadcrumbItem"
                              >
                                <span>
                                  {key?.charAt(0)?.toUpperCase() + key?.slice(1)}
                                  :
                                  {value?.includes("-")
                                    ? value?.slice(0, value?.indexOf("-"))
                                    : value}
                                </span>
                                <span>
                                  <img
                                    src={closeIcon}
                                    height="15px"
                                    width="15px"
                                    onClick={() =>
                                      handleFilterRemove(key, value)
                                    }
                                    className="workflow-auditor-filter-close-icon"
                                    alt={`Remove filter: ${key}`}
                                  />
                                </span>
                              </Badge>
                            )}
                          </div>
                        );
                      }
                    })}
                  </div>
                  {hasValue && (
                    <div className="workflow-filters-reset-container">
                      {" "}
                      <Button
                        onClick={handleReset}
                        className="workflow-filters-reset-btn"
                      >
                        Clear All
                      </Button>
                    </div>
                  )}
                </div>
              )}
              {/* </div> */}
              {showFilterSection && (

                <div className="workflow-auditor-filter-container">
                  <div className="workflow-auditor-filter-card">
                    <label className="workflow-auditor-filter-label">
                      Separation Date From
                    </label>
                    <DatePicker
                      selected={filtersPayload.separation_date_from || ""}
                      onChange={(date) => {
                        handleHimDatePickerChange("separation_date_from", date);
                      }}
                      dateFormat={dateFormat}
                      showYearDropdown
                      yearDropdownItemNumber={150}
                      scrollableYearDropdown
                      placeholderText="From"
                      className="workflow-auditor-filter-date-picker"
                    />
                  </div>
                  <div className="workflow-auditor-filter-card">
                    <label className="workflow-auditor-filter-label">
                      Separation Date To
                    </label>
                    <DatePicker
                      selected={filtersPayload.separation_date_to || ""}
                      onChange={(date) => {
                        handleHimDatePickerChange("separation_date_to", date);
                      }}
                      dateFormat={dateFormat}
                      showYearDropdown
                      yearDropdownItemNumber={150}
                      scrollableYearDropdown
                      placeholderText="To"
                      className="workflow-auditor-filter-date-picker"
                    />
                  </div>
                  <div className="workflow-auditor-filter-card">
                    <label
                      className="workflow-auditor-filter-label"
                      htmlFor="speciality"
                    >
                      Specialty
                    </label>
                    <Dropdown className="workflow-auditor-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="speciality"
                        className="workflow-auditor-filter-card-label"
                      >
                        Speciality
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-auditor-filter-select">
                        <div>
                          <div>
                            {!specialityLoading &&
                              specialityData?.length > 0 && (
                                <input
                                  className="workflow-auditor-filter-dropdown-search-input"
                                  type="text"
                                  value={specialitySearchValue}
                                  onChange={(e) =>
                                    setSpecialitySearchValue(e.target.value)
                                  }
                                  placeholder="Search"
                                />
                              )}
                          </div>
                          <div className="workflow-auditor-filter-dropdown-options-container">
                            {specialityLoading ? (
                              <div className="filter-loader">
                                <Spinner />
                              </div>
                            ) : specialityData?.length > 0 ? (
                              specialityData
                                ?.filter((item) =>
                                  item
                                    ?.toLowerCase()
                                    ?.includes(
                                      specialitySearchValue?.toLowerCase()
                                    )
                                )
                                ?.map((item) => (
                                  <Form.Check
                                    key={item}
                                    type="checkbox"
                                    className="workflow-auditor-dropdown-menu-options"
                                    label={item}
                                    value={item}
                                    checked={
                                      filtersPayload.speciality?.includes(
                                        item
                                      ) || false
                                    }
                                    onChange={() =>
                                      handleHimSelectChange("speciality", item)
                                    }
                                  />
                                ))
                            ) : (
                              <div className="filter-no-options">
                                No Options
                              </div>
                            )}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-auditor-filter-card">
                    <label
                      className="workflow-auditor-filter-label"
                      htmlFor="queue"
                    >
                      Current Queue
                    </label>
                    <Dropdown className="workflow-auditor-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="queue"
                        className="workflow-auditor-filter-card-label"
                      >
                        Current Queue
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-auditor-filter-select">
                        <div>
                          {!queueLoading && queueData?.length > 0 && (
                            <div>
                              <input
                                className="workflow-auditor-filter-dropdown-search-input"
                                type="text"
                                value={currentQueueSearchValue}
                                onChange={(e) =>
                                  setCurrentQueueSearchValue(e.target.value)
                                }
                                placeholder="Search"
                              />
                            </div>
                          )}
                          <div className="workflow-auditor-filter-dropdown-options-container">
                            {queueLoading ? (
                              <div className="filter-loader">
                                <Spinner />
                              </div>
                            ) : queueData?.length > 0 ? (
                              queueData
                                ?.filter((item) =>
                                  item?.queue_name
                                    ?.toLowerCase()
                                    ?.includes(
                                      currentQueueSearchValue?.toLowerCase()
                                    )
                                )
                                .map((item) => (
                                  <Form.Check
                                    key={item}
                                    type="checkbox"
                                    className="workflow-auditor-dropdown-menu-options"
                                    label={item.queue_name}
                                    value={item.queue_id}
                                    checked={
                                      filtersPayload.queue?.includes(
                                        item.queue_id
                                      ) || false
                                    }
                                    onChange={() =>
                                      handleHimSelectChange(
                                        "queue",
                                        item.queue_id
                                      )
                                    }
                                  />
                                ))
                            ) : (
                              <div className="filter-no-options">
                                No Options
                              </div>
                            )}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-auditor-filter-card">
                    <label
                      className="workflow-auditor-filter-label"
                      htmlFor="ur_number"
                    >
                      UR Number
                    </label>
                    <Dropdown className="workflow-auditor-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="ur_number"
                        className="workflow-auditor-filter-card-label"
                      >
                        UR Number
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-auditor-filter-select">
                        <div>
                          {!episodesURnumberLoading &&
                            episodesURnumberData.length > 0 && (
                              <div>
                                <input
                                  className="workflow-auditor-filter-dropdown-search-input"
                                  type="text"
                                  value={codersSearchValue}
                                  onChange={(e) =>
                                    setCodersSearchValue(e.target.value)
                                  }
                                  placeholder="Search"
                                />
                              </div>
                            )}
                          <div className="workflow-auditor-filter-dropdown-options-container">
                            <div className="workflow-auditor-filter-dropdown-options-container">
                              {episodesURnumberData?.length > 0 ? (
                                episodesURnumberData
                                  ?.filter((item) =>
                                    item.ur_number
                                      ?.toLowerCase()
                                      .includes(
                                        codersSearchValue?.toLowerCase()
                                      )
                                  )
                                  .map((item) => (
                                    <Form.Check
                                      key={item}
                                      type="checkbox"
                                      className="workflow-auditor-dropdown-menu-options"
                                      label={item.ur_number}
                                      value={item.ur_number}
                                      checked={
                                        filtersPayload.ur_number?.includes(
                                          item.ur_number
                                        ) || false
                                      }
                                      onChange={() =>
                                        handleHimSelectChange(
                                          "ur_number",
                                          item.ur_number
                                        )
                                      }
                                    />
                                  ))
                              ) : (
                                <div className="filter-no-options">
                                  No Options
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-auditor-filter-card">
                    <label
                      className="workflow-auditor-filter-label"
                      htmlFor="queue_priority"
                    >
                      Priority
                    </label>
                    <Dropdown className="workflow-auditor-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="queue_priority"
                        className="workflow-auditor-filter-card-label"
                      >
                        Priority
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-auditor-filter-select">
                        <div>
                          <div>
                            <input
                              className="workflow-auditor-filter-dropdown-search-input"
                              type="text"
                              value={prioritySearchValue}
                              onChange={(e) =>
                                setPrioritySearchValue(e.target.value)
                              }
                              placeholder="Search"
                            />
                          </div>
                          <div className="workflow-auditor-filter-dropdown-options-container">
                            {renderDropdownOptions(
                              "queue_priority",
                              auditorViewFiltersPriority?.length > 0
                                ? auditorViewFiltersPriority
                                : [],
                              filtersPayload?.queue_priority,
                              prioritySearchValue
                            )}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="workflow-auditor-filter-card">
                    <label
                      className="workflow-auditor-filter-label"
                      htmlFor="status"
                    >
                      Status
                    </label>
                    <Dropdown className="workflow-auditor-filter-card-dropdown">
                      <Dropdown.Toggle
                        id="status"
                        className="workflow-auditor-filter-card-label"
                      >
                        Status
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="workflow-auditor-filter-select">
                        <div>
                          <div>
                            <input
                              className="workflow-auditor-filter-dropdown-search-input"
                              type="text"
                              value={statusSearchValue}
                              onChange={(e) =>
                                setStatusSearchValue(e.target.value)
                              }
                              placeholder="Search"
                            />
                          </div>
                          <div className="workflow-auditor-filter-dropdown-options-container">
                            {(auditorViewFiltersStatus?.length > 0
                              ? [
                                ...new Set(
                                  auditorViewFiltersStatus.filter((item) =>
                                    item
                                      ?.toLowerCase()
                                      .includes(
                                        statusSearchValue?.toLowerCase()
                                      )
                                  )
                                ),
                              ]
                              : []
                            ).length > 0
                              ? [
                                ...new Set(
                                  auditorViewFiltersStatus?.filter((item) =>
                                    item
                                      ?.toLowerCase()
                                      .includes(
                                        statusSearchValue?.toLowerCase()
                                      )
                                  )
                                ),
                              ].map((item) => (
                                <Form.Check
                                  key={item}
                                  type="checkbox"
                                  className="workflow-auditor-dropdown-menu-options"
                                  label={item}
                                  value={item}
                                  checked={
                                    filtersPayload.status?.includes(item) ||
                                    false
                                  }
                                  onChange={() =>
                                    handleHimSelectChange("status", item)
                                  }
                                />
                              ))
                              : "No options"}
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              )}
            </>
          </div>
          <div className="workflow-auditor-table-container">
            {/* <div className="workflow-auditor-table-header">
              <div>
                {selectedHimEpisodes?.length > 0 && (
                  <Badge
                    className="workflow-auditor-table-td-assgine-btn"
                    onClick={() => {
                      setWorkflowHimsAssginModal(true);
                    }}
                  >
                    Assign
                  </Badge>
                )}
              </div>
              <div className="workflow-auditor-table-header-right">
                {selectedHimEpisodes.length > 0 ? (
                  <div className="workflow-auditor-selected-rows-count">
                    <Badge colorlassName="workflow-auditor-selected-rows-count-badge">
                      Selected Rows:
                      {selectedHimEpisodes.length}
                    </Badge>
                  </div>
                ) : (
                  <div className="workflow-auditor-selected-rows-count">
                    <Badge colorlassName="workflow-auditor-selected-rows-count-badge">
                      Total Episodes:{" "}
                      {episodesData?.length > 0 ? episodesData?.length : 0}
                    </Badge>
                  </div>
                )}
              </div>
            </div> */}
            <div className="auditor-header-container">
              <div className="workflow-auditor-table-header-search-container">
                <img src={search_icon} alt="search" style={{ height: '18px', paddingLeft: '5px' }} />
                <input className="workflow-auditor-table-header-search-input" value={filtersPayload.search_term} placeholder="Search episode identifer" onChange={handleSearchEpisode} />
              </div>
              <div className="workflow-auditor-selected-rows-count">
                <Badge colorlassName="workflow-auditor-selected-rows-count-badge">
                  Total Episodes:{" "}
                  {auditorViewData?.episode_meta_data?.meta?.total_count ? auditorViewData?.episode_meta_data?.meta?.total_count : 0}
                </Badge>
              </div>
            </div>
            <div className="workflow-auditor-table-body">
            <Table
              // responsive="sm"
              className="workflow-table-Hims"
              // style={{ width: auditorViewData ? "max-content" : "" }}
              style={{ width: "100%" }}
            >
              <thead className="workflow-auditor-table-thead">
                <tr className="workflow-auditor-table-tr">
                  {/* <th className="workflow-auditor-table-th-select">
                      <input
                        type="checkbox"
                        onChange={hanldeSelectAllHimEpisodes}
                        checked={isAllEpisodesSelected}
                        className="workflow-auditor-table-input"
                      />
                    </th> */}
                  <th className="workflow-auditor-table-th">
                    <span>MRN/UR</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Admission Date</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Discharge Date</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>LOS</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Specialty</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>NWAU​</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>$</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Audit DRG</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Audit NWAU</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Audit $</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Current Queue​</span>
                  </th>
                  {/* <th className="workflow-auditor-table-th">
                  <span>Assigned User</span>
                </th> */}
                  <th className="workflow-auditor-table-th">
                    <span>Priority</span>
                  </th>
                  <th className="workflow-auditor-table-th">
                    <span>Status</span>
                  </th>
                </tr>
              </thead>
              <tbody className="workflow-auditor-table-body">
                {auditorViewDataLoading ? (
                  <tr>
                    <td colspan="14">
                      <div className="workflow-auditor-table-loader">
                        <LdsRoller />
                      </div>
                    </td>
                  </tr>
                ) : auditorViewDataError ? (
                  <tr>
                    <td colspan="14">
                      <div className="workflow-auditor-table-error">
                        No data found
                      </div>
                    </td>
                  </tr>
                ) : dataToDisplay?.length > 0 ? (
                  dataToDisplay?.map((HimTableItem) => {
                    return (
                      <tr
                        key={HimTableItem?.hcp_line_id}
                        // draggable
                        // onDragStart={(e) => handleDragStart(e, HimTableItem)}
                        className="workflow-auditor-table-tr"
                        onDoubleClick={() =>
                          checkAuditorPermissionAndNavigate(
                            HimTableItem
                          )
                        }
                      >
                        {/* <td className="workflow-auditor-table-td">
                            <input
                              type="checkbox"
                              className="workflow-auditor-table-input"
                              checked={selectedHimEpisodes?.some(
                                (episode) =>
                                  episode === HimTableItem?.hcp_line_id
                              )}
                              onChange={(e) =>
                                handleHimRowSelection(e, HimTableItem)
                              }
                            />
                          </td> */}
                        <td className="workflow-auditor-table-td">
                          <div style={{ padding: "7px 10px" }}>
                            {/* {HimTableItem?.medical_record_number} */}
                            {getHighlightedText(HimTableItem?.medical_record_number)}

                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.admission_date}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.separation_date!==null ? HimTableItem?.separation_date : "-"}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.length_of_stay}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.speciality
                                ? HimTableItem?.speciality
                                : "-"}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                                 {Number(HimTableItem?.weight)
                              ? Number(HimTableItem?.weight).toFixed(4)
                              : 0}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {Number?.isFinite(HimTableItem?.weight)
                                  ? Math.round(HimTableItem?.weight * 6465
                                  ).toLocaleString("en-IN")
                                : 0}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.audit_drg !== null
                                ? HimTableItem?.audit_drg
                                : "No DRG"}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.audit_weight
                                ? Number(HimTableItem?.audit_weight).toFixed(4)
                                : 0}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <div style={{ padding: "7px 10px" }}>
                              {HimTableItem?.audit_weight
                                ? Math.round(
                                    HimTableItem?.audit_weight * 6465
                                  ).toLocaleString()
                                : 0}
                            </div>
                          </td>
                          <td className="workflow-auditor-table-td">
                            <Badge className="workflow-auditor-current_queue">
                              <div>
                                <img
                                  src={userIcon}
                                  alt=""
                                  height="15px"
                                  width="15px"
                                  className="me-2"
                                />
                              </div>
                              <div>
                                {HimTableItem?.queue
                                  ? HimTableItem?.queue
                                  : "-"}
                              </div>
                            </Badge>
                          </td>
                          {/* <td className="workflow-auditor-table-td">
                      {HimTableItem?.assigned_user ? HimTableItem?.assigned_user : "-"}
                    </td> */}
                        <td className="workflow-auditor-table-td">
                          {/* {HimTableItem.Priority} */}
                          <Badge
                            className="workflow-auditor-priority"
                            ref={(el) => {
                              if (el) {
                                el.style.setProperty(
                                  "background-color",
                                  HimTableItem?.priority === "URGENT"
                                    ? "#FDF2FA"
                                    : HimTableItem?.priority === "HIGH"
                                      ? "#FEF6EE"
                                      : HimTableItem?.priority === "LOW"
                                        ? "#F9FAFB"
                                        : HimTableItem?.priority === "OVERDUE"
                                          ? "#FEFCE8"
                                          : "",
                                  "important"
                                );
                                el.style.setProperty(
                                  "border",
                                  `1px solid ${HimTableItem?.priority === "URGENT"
                                    ? "#FCCEEE"
                                    : HimTableItem?.priority === "HIGH"
                                      ? "#F9DBAF"
                                      : HimTableItem?.priority === "LOW"
                                        ? "#EAECF0"
                                        : HimTableItem?.priority === "OVERDUE"
                                          ? "#F9DBAF"
                                          : ""
                                  }`,
                                  "important"
                                );
                                el.style.setProperty(
                                  "color",
                                  `${HimTableItem?.priority === "URGENT"
                                    ? "#C11574"
                                    : HimTableItem?.priority === "HIGH"
                                      ? "#D28800"
                                      : HimTableItem?.priority === "LOW"
                                        ? "#344054"
                                        : HimTableItem?.priority === "OVERDUE"
                                          ? "#344054"
                                          : ""
                                  }`,
                                  "important"
                                );
                              }
                            }}
                            style={{
                              border: "1px solid #FCCEEE",
                              backgroundColor: HimTableItem?.PriorityColor,
                            }}
                          >
                            {HimTableItem?.priority}
                            {/* Badge Content Here */}
                          </Badge>
                        </td>
                        <td className="workflow-auditor-table-td">
                          <Badge
                            ref={(badge) => {
                              if (badge) {
                                badge.style.setProperty(
                                  "background-color",
                                  "#FFF",
                                  "important"
                                );
                                badge.style.setProperty(
                                  "border",
                                  // HimTableItem?.status === "AI processing complete - codes available for validation" ? " 1px solid #4CAF50" : HimTableItem?.status === "Audited" ? "1px solid #2E7D32"  : HimTableItem?.status === "Awaiting Audit" ? "1px solid #FFA726" : HimTableItem?.status === "Awaiting CDQ" ? "1px solid #FFB300" : HimTableItem?.status === "CDQ For Review" ? "1px solid #FB8C00" : HimTableItem?.status === "Coding Complete" ? "1px solid #00897B" : HimTableItem?.status === "Locked by user" ? "1px solid #757575" : HimTableItem?.status === "Missing Notes" ? "1px solid #E53935" : HimTableItem?.status === "On Hold" ? "1px solid 6A1B9A" : HimTableItem?.status === "Outstanding" ? "1px solid #F44336" : "black",
                                  // "1px solid #D0D5DD",
                                  "1px solid black",
                                  "important"
                                );
                                badge.style.setProperty(
                                  "color",
                                  HimTableItem?.status ===
                                    "Audit - AI processing complete - codes available for validation"
                                    ? " #4CAF50"
                                    : HimTableItem?.status ===
                                      "Audit - Audited"
                                      ? "#2E7D32"
                                      : HimTableItem?.status ===
                                        "Audit - Awaiting Audit"
                                        ? "#FFA726"
                                        : HimTableItem?.status ===
                                          "Audit - Awaiting CDQ"
                                          ? "#FFB300"
                                          : HimTableItem?.status ===
                                            "Audit - CDQ For Review"
                                            ? "#FB8C00"
                                            : HimTableItem?.status ===
                                              "Audit - Coding Complete"
                                              ? "#00897B"
                                              : HimTableItem?.status ===
                                                "Audit - Locked by user"
                                                ? "#757575"
                                                : HimTableItem?.status ===
                                                  "Audit - Missing Notes"
                                                  ? "#E53935"
                                                  : HimTableItem?.status ===
                                                    "Audit - On Hold"
                                                    ? "#6A1B9A"
                                                    : HimTableItem?.status ===
                                                      "Audit - Outstanding"
                                                      ? "#F44336"
                                                      : "black",
                                  // "black",
                                  "important"
                                );
                                badge.style.setProperty("display", "flex");
                                // {episode.status === "AI processing complete - codes available for validation" ?  badge.style.setProperty("color", "white") : badge.style.setProperty("color", "#344054")}
                                badge.style.setProperty(
                                  "align-items",
                                  "center"
                                );
                                badge.style.setProperty(
                                  "justify-content",
                                  "center"
                                );
                                badge.style.setProperty("height", "30px");
                                badge.style.setProperty("width", "100%");
                                // badge.style.setProperty("padding", "0px 20px");
                                badge.style.setProperty("font-size", "12px");
                                badge.style.setProperty(
                                  "font-weight",
                                  "800",
                                  "important"
                                ); // Allow text to wrap
                                badge.style.setProperty(
                                  "white-space",
                                  "normal"
                                ); // Allow text to wrap
                                badge.style.setProperty("overflow", "hidden"); // Hide overflowed text
                                badge.style.setProperty(
                                  "text-overflow",
                                  "ellipsis"
                                ); // Add ellipsis if text overflows
                              }
                            }}
                          >
                            <Tooltip title={HimTableItem?.status || "-"}>
                              {HimTableItem?.status || "-"}
                            </Tooltip>
                          </Badge>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <td colspan="14">
                    <div className="workflow-auditor-table-no-records">
                      No records found
                    </div>
                  </td>
                )}
              </tbody>
            </Table>
            </div>
            <div className="auditorTable-footer">
              <div>
                {/* <Pagination className="HimTable-pagination">
                  <Pagination.First
                    onClick={() => handlePageChange(1)}
                    disabled={episodesCurrentPage <= 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(episodesCurrentPage - 1)}
                    disabled={episodesCurrentPage <= 1}
                    className="HimTable-prev-btn"
                  />
                  <Pagination.Item>
                    Page {episodesCurrentPage} of {totalPages}
                  </Pagination.Item>

                  <Pagination.Next
                    onClick={() => handlePageChange(episodesCurrentPage + 1)}
                    disabled={episodesCurrentPage >= totalPages}
                    className="HimTable-next-btn"
                  />
                  <Pagination.Last
                    onClick={() => handlePageChange(totalPages)}
                    disabled={episodesCurrentPage === totalPages}
                  />
                </Pagination> */}
                <Pagination className="auditor-pagination">
                  <Pagination.First className="auditor-pagination-li"
                    onClick={() => handlePageChange(1)}
                    disabled={filtersPayload?.page_number <= 1}
                  />
                  <Pagination.Prev
                    onClick={() => handlePageChange(filtersPayload?.page_number - 1)}
                    disabled={filtersPayload?.page_number <= 1}
                    className="auditor-prev-btn"
                  />
                  <Pagination.Item className="auditor-pagination-li">
                    Page {filtersPayload?.page_number} of {totalPages}
                  </Pagination.Item>
                  <Pagination.Next
                    onClick={() => handlePageChange(filtersPayload?.page_number + 1)}
                    disabled={filtersPayload?.page_number >= totalPages}
                    className="auditor-next-btn"
                  />
                  <Pagination.Last className="auditor-pagination-li"
                    onClick={() => handlePageChange(totalPages)}
                    disabled={filtersPayload?.page_number === totalPages}
                  />
                </Pagination>
              </div>
              {/* <div className="HimTable-row-options">
                <Form.Select
                  className="HimTable-select"
                  value={episodesPerPage}
                  onChange={handleRowsPerPageChange}
                >
                  <option value="" disabled className="HimTable-rows-per-page">
                    Rows per page
                  </option>
                  <option value={10} className="HimTable-rows-per-page">
                    10
                  </option>
                  <option value={20} className="HimTable-rows-per-page">
                    20
                  </option>
                  <option value={50} className="HimTable-rows-per-page">
                    50
                  </option>
                </Form.Select>
              </div> */}
            </div>
          </div>
        </div>
        {preferencesLoading ? (
          <div
            className="modal fade coding-screen-popup user-preference-modal show"
            style={{ display: "block" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body text-center py-5">
                  <p className="mt-3">Loading preferences...</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          showUserPreferenceModal && (
            <div
              className="modal fade coding-screen-popup user-preference-modal show"
              style={{ display: "block" }}
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={() => setShowUserPreferenceModal(false)}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    Kindly select your desired coding module
                  </div>
                  <div className="modal-footer mb-3">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => navigateToDesiredPage("assist")}
                    >
                      Code Assist
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => navigateToDesiredPage("accelerate")}
                    >
                      Code Accelerate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )
        )}

        {/* { workflowHimsAssginModal &&<HealthInformationManagerAssignModal 
      workflowHimsAssginModal = {workflowHimsAssginModal}
       setWorkflowHimsAssginModal = {setWorkflowHimsAssginModal}
       selectedRecord = {selectedRecord}
       isAllEpisodesSelected={isAllEpisodesSelected}
       selectedHimEpisodes={selectedHimEpisodes}
       handleHimSelectChange={handleHimSelectChange}
       uncheckedIds={uncheckedIds}
    />} */}
      </div>
    </>
  );
};

export default AuditorView;